import { AppManager } from "@/lib/application/AppManager";
import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import * as React from "react";
import { Spinner } from "@/components/ui/spinner";
import { Toaster } from "sonner";
import { AnalyticsProvider } from "@/app/providers/analytics-provider";
import { ThemeProvider } from "@/app/providers/theme-provider";
import AudioProvider from "@/app/providers/audio-provider";
import AppProvider from "@/app/providers/app-provider";
import { BrowserRouter } from "react-router";
import { AppErrorBoundary } from "@/components/errors/app-error-boundary";
import ReferralProvider from "@/app/providers/referral-provider";
import AttributionProvider from "@/app/providers/attribution-provider";
import { AppVersionWatcher } from "@/components/app-version-watcher";

type AppProviderProps = {
	children: React.ReactNode;
};

export const Providers = ({ children }: AppProviderProps) => {
	const appManager = AppManager.getInstance();
	const queryClient = appManager.queryClient;

	return (
		<React.Suspense
			fallback={
				<div className="flex h-screen w-screen items-center justify-center">
					<Spinner size="xl" />
				</div>
			}
		>
			<AppErrorBoundary>
				<AnalyticsProvider>
					<BrowserRouter>
						<ThemeProvider>
							<AppProvider appManager={appManager}>
								<QueryClientProvider client={queryClient}>
									<AudioProvider>
										<ReferralProvider>
											<AttributionProvider>
												{/* Development tools - Temporarily disabled to fix E2E tests */}
												{/* {import.meta.env.MODE === "development" &&
													import.meta.env.VITE_TEST_MODE !== "true" && (
														<ReactQueryDevtools />
													)} */}
												<Toaster />
												<AppVersionWatcher />
												{children}
											</AttributionProvider>
										</ReferralProvider>
									</AudioProvider>
								</QueryClientProvider>
							</AppProvider>
						</ThemeProvider>
					</BrowserRouter>
				</AnalyticsProvider>
			</AppErrorBoundary>
		</React.Suspense>
	);
};
